import React, {PropsWithChildren, useRef, useState} from 'react';
import b_ from 'b_';

import {Button, Icon, Popup} from 'client/common/components/lego';

import './help-block.css';

const b = b_.with('help-block');

type BlockInputProps = PropsWithChildren<{
    className?: string;
    popupContent?: React.ReactNode;
    direction?: 'bottom' | 'left';
}>;

export default function HelpBlock(props: BlockInputProps) {
    const {children, className = '', direction = 'bottom'} = props;
    const wrapperRef = useRef(null);

    const [displayPopup, setDisplayPopup] = useState(false);

    return (
        <div className={`${b()} ${className}`}>
            <Button
                className={b('help-icon')}
                innerRef={wrapperRef}
                icon={(mix: string) => <Icon className={mix} type='help' />}
                onClick={() => setDisplayPopup(true)}
                size='icon'
                view='clear'
            />
            <Popup
                anchor={wrapperRef}
                onClose={() => setDisplayPopup(false)}
                className={b('info-popup')}
                direction={direction}
                target='anchor'
                view='default'
                visible={displayPopup}
            >
                <div className={b('content')}>{children}</div>
            </Popup>
        </div>
    );
}
